import TextArea from 'antd/es/input/TextArea';
import MyInput from '../../../components/ui/MyInput';
import { Dropdown } from 'primereact/dropdown';
import { useEffect, useState } from 'react';
import UploadImgPublish from '../../../components/ui/UploadImgPublish';
import Toggle from '../../ThemeScreen/DnDNew/components/DnDItems/DnDSidebarItems/Inputs/Toggle';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { translate } from '../../../utils/language';
import systemSlice from '../../../redux/systemSlice';
const ArrayOf4 = Array.from({ length: 5 });

const Images = ({ imagesFormButtonRef, data, setData, onSave }) => {
  const [isOpen, setIsOpen] = useState(false);
  const app = useSelector(state => state.myAppsSlice?.localReduxData.app);
  const dispatch = useDispatch();
  const initialImagesData = {
    appLogo: app?.appLogo,
    googlePlayPlaceholder: '',
    splashScreen: '',
    placeholderImage: '',
    storePreviewImages: [],
    youtubeVideoUrl: '',
  };
  const [imagesData, setImagesData] = useState(initialImagesData);

  const updateImages = (key, value) => {
    setImagesData(state => ({ ...state, [key]: value }));
  };

  useEffect(() => {
    const newImagesData = { ...initialImagesData };
    Object.keys(data).map(key => {
      if (key in initialImagesData && data[key]) {
        newImagesData[key] = data[key];
      }
    });

    setImagesData(newImagesData);
  }, []);

  const defaultCustomImages = ArrayOf4.map((_, index) => {
    return (
      <div className="flex-1">
        <UploadImgPublish
          accept={{
            'image/png': ['.png'],
          }}
          output={{ width: 1242, height: 2688 }}
          preImage={imagesData.storePreviewImages[index]}
          boxHeight={292.175}
          boxWidth={135}
          imageWidth="120"
          imageHeight="120"
          onChange={e => {
            setImagesData(state => {
              const newState = { ...state };
              const storePreviewImages = newState.storePreviewImages;
              storePreviewImages[index] = e;
              newState.storePreviewImages = storePreviewImages;
              return newState;
            });
          }}
          label=""
          placeholder=""
          text={''}
          obJectFit={'cover'}
          error={'error'}
          uploadType={2}
          resolution={'1242x2688'}
        />
      </div>
    );
  });

  return (
    <form
      className="flex flex-col gap-[20px] items-center"
      onSubmit={e => {
        e.preventDefault();
        e.stopPropagation();
        const { appLogo, splashScreen, placeholderImage, storePreviewImages, googlePlayPlaceholder } = imagesData;
        if (
          !appLogo ||
          !splashScreen ||
          !placeholderImage ||
          (isOpen && storePreviewImages?.length < 3) ||
          !googlePlayPlaceholder
        ) {
          dispatch(systemSlice.actions.setToastError({ detail: translate('missingPublishImages') }));
          return;
        }
        setData(state => ({ ...state, images: imagesData }));
        onSave();
      }}
    >
      <div className="bg-white p-4 rounded-lg shadow-xl w-[99%] mb-2">
        <div id="Region-information">
          <div className="section-header bg-slate-50 border-b-2 border-slate-200 p-4 mb-6">
            <h2 className="text-2xl font-bold text-gray-900">🖼️ Görsel Materyaller</h2>
            <p className="text-gray-600 mt-2">
              Görsel materyaller, kullanıcıların indirme kararını %50 oranında etkiler. Profesyonel ve dikkat çekici
              görseller hazırlayın.
            </p>
          </div>

          <div className="flex flex-col gap-[10px] items-center ">
            <div
              style={{
                textAlign: 'left',
                width: '100%',
                display: 'flex',
              }}
            >
              Uygulama Ikonu
              <div className="relative group cursor-pointer ml-1">
                <svg
                  fill="#3A80F6"
                  width="20px"
                  height="20px"
                  viewBox="0 0 12.8 12.8"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>ionicons-v5-e</title>
                  <path d="M6.4 1.4C3.643 1.4 1.4 3.643 1.4 6.4s2.243 5 5 5 5 -2.243 5 -5S9.157 1.4 6.4 1.4m0 2.05a0.65 0.65 0 1 1 -0.65 0.65 0.65 0.65 0 0 1 0.65 -0.65m1.2 5.65h-2.2a0.4 0.4 0 0 1 0 -0.8h0.7v-2.2h-0.4a0.4 0.4 0 0 1 0 -0.8h0.8a0.4 0.4 0 0 1 0.4 0.4v2.6h0.7a0.4 0.4 0 0 1 0 0.8" />
                </svg>
                <div className="absolute bottom-full mb-1 h-max  w-max max-w-[300px] bg-[#1D40AF] text-white text-xs rounded py-2 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                  • Uygulama ikonunuz basit, tanınabilir ve markanıza uygun olmalı.
                  <br />
                  • 1024x1024px boyutunda, köşeleri yuvarlatılmamış ve arka planı opak (transparan değil) olmalı.
                  <br />• Küçük boyutlarda da net görünecek şekilde tasarlanmalı.
                </div>
              </div>
            </div>
            <div>
              <UploadImgPublish
                accept={{
                  'image/png': ['.png'],
                }}
                required
                output={{ width: 1024, height: 1024 }}
                preImage={imagesData?.appLogo}
                boxHeight={250}
                boxWidth={250}
                onChange={e => {
                  updateImages('appLogo', e);
                }}
                label=""
                placeholder=""
                text={''}
                obJectFit={'cover'}
                error={'error'}
                uploadType={2}
                resolution={'1024x1024'}
                imageText={'*Görsel tam istenilen boyutta olmalıdır'}
              />
            </div>
            <div className="info-box mt-8 bg-slate-50 border-l-4 border-indigo-500 p-4 text-sm text-slate-600  mb-6 w-[100%]">
              <p className="font-medium">💡 Neden Önemli?</p>
              <ul className="list-disc ml-4 mt-1">
                <li>Uygulama ikonu, kullanıcının gördüğü ilk şeydir.</li>
                <li>App Store ve Google Play'de listelenen uygulamaların %90'ı ikonlarıyla tanınır.</li>
                <li>İyi tasarlanmış bir ikon, tıklanma ve indirme oranını %20’ye kadar artırabilir.</li>
                <li>Kalitesiz ya da şeffaf ikonlar, başvuru reddine veya düşük kullanıcı güvenine yol açabilir. </li>
              </ul>
            </div>
          </div>

          <div className="flex flex-col gap-[10px] items-center ">
            <div
              style={{
                textAlign: 'left',
                width: '100%',
                display: 'flex',
              }}
            >
              Uygulama Mağazası Önizleme Görselleri
              <div className="relative group cursor-pointer ml-1">
                <svg
                  fill="#3A80F6"
                  width="20px"
                  height="20px"
                  viewBox="0 0 12.8 12.8"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>ionicons-v5-e</title>
                  <path d="M6.4 1.4C3.643 1.4 1.4 3.643 1.4 6.4s2.243 5 5 5 5 -2.243 5 -5S9.157 1.4 6.4 1.4m0 2.05a0.65 0.65 0 1 1 -0.65 0.65 0.65 0.65 0 0 1 0.65 -0.65m1.2 5.65h-2.2a0.4 0.4 0 0 1 0 -0.8h0.7v-2.2h-0.4a0.4 0.4 0 0 1 0 -0.8h0.8a0.4 0.4 0 0 1 0.4 0.4v2.6h0.7a0.4 0.4 0 0 1 0 0.8" />
                </svg>
                <div className="absolute bottom-full mb-1 h-max  w-max max-w-[300px] bg-[#1D40AF] text-white text-xs rounded py-2 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                  • Gerçek ekran görüntüleri veya tanıtım görselleri kullanın.
                  <br />
                  • Farklı cihaz çözünürlüklerine uygun, yüksek kaliteli görseller hazırlayın.
                  <br />
                  • Uygulamanızın ana işlevlerini ve arayüzünü net şekilde göstermeli.
                  <br />• Fazla metin kullanmayın, sade ve açıklayıcı görseller tercih edin.
                </div>
              </div>
            </div>
            <Toggle
              value={isOpen}
              setItem={() => {
                setIsOpen(state => !state);
              }}
              targetKey={'uploadCustomStoreImage'}
            />
            <div className="flex flex-row gap-[20px] flex-wrap">
              {isOpen ? (
                defaultCustomImages
              ) : (
                <div className="text-sm pt-[10px] py-2 text-[#8A92A6] text-[15px] font-medium">
                  Uygulama Mağazası Önizleme Görselleri otomatik olarak oluşturulacaktır.
                </div>
              )}
            </div>
            <div className="info-box mt-8 bg-slate-50 border-l-4 border-indigo-500 p-4 text-sm text-slate-600  mb-6 w-[100%]">
              <p className="font-medium">💡 Neden Önemli?</p>
              <ul className="list-disc ml-4 mt-1">
                <li>Kullanıcılar uygulama hakkında ilk izlenimi görsellerden edinir.</li>
                <li>Kaliteli ve açıklayıcı görseller, indirme kararını doğrudan etkiler.</li>
                <li>App Store ve Play Store’da düşük kaliteli veya eksik görseller ret sebebi olabilir.</li>
              </ul>
            </div>
          </div>
          <div className="flex flex-col gap-[10px] items-center">
            <div
              style={{
                textAlign: 'left',
                width: '100%',
                display: 'flex',
              }}
            >
              Google Play Özellik Grafiği
              <div className="relative group cursor-pointer ml-1">
                <svg
                  fill="#3A80F6"
                  width="20px"
                  height="20px"
                  viewBox="0 0 12.8 12.8"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>ionicons-v5-e</title>
                  <path d="M6.4 1.4C3.643 1.4 1.4 3.643 1.4 6.4s2.243 5 5 5 5 -2.243 5 -5S9.157 1.4 6.4 1.4m0 2.05a0.65 0.65 0 1 1 -0.65 0.65 0.65 0.65 0 0 1 0.65 -0.65m1.2 5.65h-2.2a0.4 0.4 0 0 1 0 -0.8h0.7v-2.2h-0.4a0.4 0.4 0 0 1 0 -0.8h0.8a0.4 0.4 0 0 1 0.4 0.4v2.6h0.7a0.4 0.4 0 0 1 0 0.8" />
                </svg>
                <div className="absolute bottom-full mb-1 h-max  w-max max-w-[300px] bg-[#1D40AF] text-white text-xs rounded py-2 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                  • 1024x500 px boyutunda yatay bir görsel olmalı.
                  <br />
                  • Markanızı, logo ve renklerinizi barındıran tanıtım amaçlı bir grafik kullanın.
                  <br />• Arayüz görüntüsü içermez; daha çok tanıtım posteri gibidir.
                </div>
              </div>
            </div>
            <div>
              <UploadImgPublish
                accept={{
                  'image/png': ['.png'],
                }}
                required
                output={{ width: 1024, height: 500 }}
                preImage={imagesData?.googlePlayPlaceholder}
                boxHeight={250}
                boxWidth={512}
                onChange={e => {
                  updateImages('googlePlayPlaceholder', e);
                }}
                label=""
                placeholder=""
                text={''}
                obJectFit={'cover'}
                error={'error'}
                uploadType={2}
                resolution={'1024x512'}
                imageText={'*Görsel tam istenilen boyutta olmalıdır'}
              />
            </div>
            <div className="info-box mt-8 bg-slate-50 border-l-4 border-indigo-500 p-4 text-sm text-slate-600  mb-6 w-[100%]">
              <p className="font-medium">💡 Neden Önemli?</p>
              <ul className="list-disc ml-4 mt-1">
                <li>Play Store'da uygulama listelemenizde en üstte gösterilir.</li>
                <li>Öne çıkan grafik, marka imajınızı ve güveni yansıtır.</li>
                <li>Play Store önerilerinde yer almak için zorunlu bir kriterdir.</li>
              </ul>
            </div>
          </div>

          <div className="flex flex-col gap-[10px] items-center">
            <div
              style={{
                textAlign: 'left',
                width: '100%',
                display: 'flex',
              }}
            >
              Yükleme Önizlemesi
              <div className="relative group cursor-pointer ml-1">
                <svg
                  fill="#3A80F6"
                  width="20px"
                  height="20px"
                  viewBox="0 0 12.8 12.8"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>ionicons-v5-e</title>
                  <path d="M6.4 1.4C3.643 1.4 1.4 3.643 1.4 6.4s2.243 5 5 5 5 -2.243 5 -5S9.157 1.4 6.4 1.4m0 2.05a0.65 0.65 0 1 1 -0.65 0.65 0.65 0.65 0 0 1 0.65 -0.65m1.2 5.65h-2.2a0.4 0.4 0 0 1 0 -0.8h0.7v-2.2h-0.4a0.4 0.4 0 0 1 0 -0.8h0.8a0.4 0.4 0 0 1 0.4 0.4v2.6h0.7a0.4 0.4 0 0 1 0 0.8" />
                </svg>
                <div className="absolute bottom-full mb-1 h-max  w-max max-w-[300px] bg-[#1D40AF] text-white text-xs rounded py-2 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                  • Ürünler, kategori listesi veya içerik yüklenmeden önce boşluk doldurmak için kullanılan görseldir.
                  <br />• Uygulamanızın tasarımına uygun, sade ve dikkat dağıtmayacak şekilde olmalıdır.
                  <br />• Gerçek içeriğe benzer boyut ve yerleşimde kullanılmalıdır.
                </div>
              </div>
            </div>
            <div>
              <UploadImgPublish
                accept={{
                  'image/png': ['.png'],
                }}
                required
                preImage={imagesData.placeholderImage}
                output={{ width: 1024, height: 1024 }}
                boxHeight={250}
                boxWidth={250}
                onChange={e => {
                  updateImages('placeholderImage', e);
                }}
                label=""
                placeholder=""
                text={''}
                obJectFit={'cover'}
                error={'error'}
                uploadType={2}
                resolution={'1024x1024'}
                imageText={'*Görsel tam istenilen boyutta olmalıdır'}
              />
            </div>
            <div className="info-box mt-8 bg-slate-50 border-l-4 border-indigo-500 p-4 text-sm text-slate-600  mb-6 w-[100%]">
              <p className="font-medium">💡 Neden Önemli?</p>
              <ul className="list-disc ml-4 mt-1">
                <li>Kullanıcıya “bir şeyler oluyor” hissini verir, bekleme süresini daha az sıkıcı hale getirir.</li>
                <li>İçeriğin geç yüklendiği durumlarda boş ekran riskini ortadan kaldırır.</li>
                <li>Uygulamanın daha hızlı ve profesyonel görünmesini sağlar.</li>
                <li>Özellikle zayıf internet bağlantısında, kullanıcı deneyimini ciddi şekilde iyileştirir.</li>
              </ul>
            </div>
          </div>

          <div className="flex flex-col gap-[10px] items-center">
            <div
              style={{
                textAlign: 'left',
                width: '100%',
                display: 'flex',
              }}
            >
              Uygulama Açılış Görseli
              <div className="relative group cursor-pointer ml-1">
                <svg
                  fill="#3A80F6"
                  width="20px"
                  height="20px"
                  viewBox="0 0 12.8 12.8"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>ionicons-v5-e</title>
                  <path d="M6.4 1.4C3.643 1.4 1.4 3.643 1.4 6.4s2.243 5 5 5 5 -2.243 5 -5S9.157 1.4 6.4 1.4m0 2.05a0.65 0.65 0 1 1 -0.65 0.65 0.65 0.65 0 0 1 0.65 -0.65m1.2 5.65h-2.2a0.4 0.4 0 0 1 0 -0.8h0.7v-2.2h-0.4a0.4 0.4 0 0 1 0 -0.8h0.8a0.4 0.4 0 0 1 0.4 0.4v2.6h0.7a0.4 0.4 0 0 1 0 0.8" />
                </svg>
                <div className="absolute bottom-full mb-1 h-max  w-max max-w-[300px] bg-[#1D40AF] text-white text-xs rounded py-2 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                  • Uygulama açıldığında kullanıcıya gösterilen ilk ekran tasarımıdır.
                  <br />• Görsel netliği, okunabilirlik ve marka rengi uyumu önemlidir.
                </div>
              </div>
            </div>
            <div>
              <UploadImgPublish
                accept={{
                  'image/png': ['.png'],
                }}
                output={{ width: 1290, height: 2796 }}
                preImage={imagesData.splashScreen}
                boxHeight={541.86}
                boxWidth={250}
                onChange={e => {
                  updateImages('splashScreen', e);
                }}
                label=""
                placeholder=""
                text={''}
                obJectFit={'cover'}
                error={'error'}
                uploadType={2}
                resolution={'1090x2796'}
                imageText={'*Görsel tam istenilen boyutta olmalıdır'}
              />
            </div>
            <div className="info-box mt-8 bg-slate-50 border-l-4 border-indigo-500 p-4 text-sm text-slate-600  mb-6 w-[100%]">
              <p className="font-medium">💡 Neden Önemli?</p>
              <ul className="list-disc ml-4 mt-1">
                <li>Kullanıcının uygulamaya dair ilk etkileşimidir.</li>
                <li>Karmaşık veya ilgisiz açılış ekranları kullanıcı kaybına yol açabilir.</li>
                <li>Net bir açılış ekranı, kullanıcıyı yönlendirir ve etkileşimi artırır.</li>
              </ul>
            </div>
          </div>

          <div className="mb-6">
            <div className="w-full">
              <MyInput
                value={imagesData.youtubeVideoUrl}
                onChange={e => updateImages('youtubeVideoUrl', e)}
                maxLength={30}
                isLengthActive
                type={'url'}
                label={<div>Tanıtım Videosu (İsteğe Bağlı)</div>}
                tooltip={<>Video ekleyen uygulamalar %25-35 daha yüksek indirme oranlarına sahip</>}
                placeholder="YouTube Video URL'si"
              />
              <div className="info-box mt-8 bg-slate-50 border-l-4 border-indigo-500 p-4 text-sm text-slate-600  mb-6 w-[100%]">
                <p className="font-medium">🎥 Video İpuçları:</p>
                <ul className="list-disc ml-4 mt-1">
                  <li>30-60 saniyelik, uygulamanın temel değerini gösteren videolar en etkilidir.</li>
                  <li>İlk 5 saniye kritik — kullanıcının ilgisini hemen çekin.</li>
                  <li>Ses olmadan da anlaşılır olmalı.</li>
                  <li>Çözünürlük en az 1080p olmalı.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* adsad */}
        </div>
      </div>
      {/* asdklj */}
      <div className="flex flex-col gap-[20px] flex-wrap">
        <div className="flex flex-row w-full gap-[40px]">
          <div className=" flex flex-col gap-[10px] w-full">
            <div className=" flex flex-row gap-[10px] w-full justify-between">
              <div className="flex flex-col gap-[10px]"></div>
            </div>
          </div>
          <div className=" flex flex-col gap-[10px] w-[250px] shrink-0">
            <div className="flex flex-col gap-[10px]"></div>
            <div className="flex flex-col gap-[10px]"></div>
          </div>
        </div>
      </div>

      <button
        className="mb-6 py-2 px-4 flex items-center justify-center bg-[#7059EF] hover:bg-[#5841D9] rounded text-[#FFFFFF] disabled:bg-[#c5bfff]  cursor-pointer disabled:cursor-not-allowed"
        type="submit"
        ref={imagesFormButtonRef}
      >
        Kaydet ve Devam Et
      </button>
    </form>
  );
};

export default Images;
